import { PlatformOption } from './types'

export const PLATFORM_OPTIONS: PlatformOption[] = [
  { title: 'Shopify', value: 'shopify' },
  { title: 'Bigcommerce', value: 'bigcommerce' },
]
